import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from 'react';

export interface SidebarContextType {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
  toggleSidebar: () => void;
}

const SidebarCollapseContext = createContext<SidebarContextType | undefined>(
  undefined
);

export const SidebarCollapseProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const toggleSidebar = useCallback(() => {
    setIsCollapsed(prev => !prev);
  }, []);

  return (
    <SidebarCollapseContext.Provider
      value={{
        isCollapsed,
        setIsCollapsed,
        toggleSidebar,
      }}
    >
      {children}
    </SidebarCollapseContext.Provider>
  );
};

export const useSidebarCollapse = () => {
  const context = useContext(SidebarCollapseContext);
  if (context === undefined) {
    throw new Error(
      'useSidebarCollapse must be used within a SidebarCollapseProvider'
    );
  }
  return context;
};
